// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"9858af96","243":"0634bbdb","980":"ed330d92"}[chunkId] + ".chunk.js";
};